module.exports = __webpack_public_path__ + "img/warning.770833cf.svg";